export interface TimerShareRollbackTarget {
  share: { id: string };
  created: boolean;
  sourceHubId: string;
}

export async function rollbackNewTimerShareAfterDeliveryFailure(
  timerShare: TimerShareRollbackTarget | null,
  deleteShare: (url: string) => Promise<unknown>,
): Promise<void> {
  if (!timerShare?.created) return;

  const hubId = encodeURIComponent(timerShare.sourceHubId);
  await deleteShare(`/api/timer-shares/${timerShare.share.id}?hubId=${hubId}`);
}